module.exports = __webpack_public_path__ + "img/consultoria2_4-3.07e89c3c.webp";